// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.
import { loginPageInfo } from "./Pages/Authentication/Login/pageinfo";
import { logoutPageInfo } from "./Pages/Authentication/Logout/pageinfo";
import { mfaLoginPageInfo } from "./Pages/Authentication/MFALogin/pageinfo";
import { recoverPageInfo } from "./Pages/Authentication/Recover/pageinfo";
import { setPasswordPageInfo } from "./Pages/Authentication/SetPassword/pageinfo";
import { homePageInfo } from "./Pages/Home/pageinfo";
import { announcementHubCreatePageInfo } from "./Pages/Hubs/Announcement/CreatePage/pageinfo";
import { announcementHubDetailPageInfo } from "./Pages/Hubs/Announcement/DetailPage/pageinfo";
import { announcementHubIndexPageInfo } from "./Pages/Hubs/Announcement/IndexPage/pageinfo";
import { announcementHubPageInfo } from "./Pages/Hubs/Announcement/pageinfo";
import { calendarEventHubCreatePageInfo } from "./Pages/Hubs/CalendarEvent/CreatePage/pageinfo";
import { calendarEventHubDetailPageInfo } from "./Pages/Hubs/CalendarEvent/DetailPage/pageinfo";
import { calendarEventHubIndexPageInfo } from "./Pages/Hubs/CalendarEvent/IndexPage/pageinfo";
import { calendarEventHubPageInfo } from "./Pages/Hubs/CalendarEvent/pageinfo";
import { hubsIndexPageInfo } from "./Pages/Hubs/IndexPage/pageinfo";
import { newsletterHubCreatePageInfo } from "./Pages/Hubs/Newsletter/CreatePage/pageinfo";
import { newsletterHubDetailPageInfo } from "./Pages/Hubs/Newsletter/DetailPage/pageinfo";
import { newsletterHubIndexPageInfo } from "./Pages/Hubs/Newsletter/IndexPage/pageinfo";
import { newsletterHubPageInfo } from "./Pages/Hubs/Newsletter/pageinfo";
import { hubsPageInfo } from "./Pages/Hubs/pageinfo";
import { permissionGroupHubCreatePageInfo } from "./Pages/Hubs/PermissionGroup/CreatePage/pageinfo";
import { permissionGroupHubDetailPageInfo } from "./Pages/Hubs/PermissionGroup/DetailPage/pageinfo";
import { permissionGroupHubIndexPageInfo } from "./Pages/Hubs/PermissionGroup/IndexPage/pageinfo";
import { permissionGroupHubPageInfo } from "./Pages/Hubs/PermissionGroup/pageinfo";
import { postHubCreatePageInfo } from "./Pages/Hubs/Post/CreatePage/pageinfo";
import { postHubDetailPageInfo } from "./Pages/Hubs/Post/DetailPage/pageinfo";
import { postHubIndexPageInfo } from "./Pages/Hubs/Post/IndexPage/pageinfo";
import { postHubPageInfo } from "./Pages/Hubs/Post/pageinfo";
import { userHubCreatePageInfo } from "./Pages/Hubs/User/CreatePage/pageinfo";
import { userHubDetailPageInfo } from "./Pages/Hubs/User/DetailPage/pageinfo";
import { userHubIndexPageInfo } from "./Pages/Hubs/User/IndexPage/pageinfo";
import { userHubPageInfo } from "./Pages/Hubs/User/pageinfo";
import { userGroupHubCreatePageInfo } from "./Pages/Hubs/UserGroup/CreatePage/pageinfo";
import { userGroupHubDetailPageInfo } from "./Pages/Hubs/UserGroup/DetailPage/pageinfo";
import { userGroupHubIndexPageInfo } from "./Pages/Hubs/UserGroup/IndexPage/pageinfo";
import { userGroupHubPageInfo } from "./Pages/Hubs/UserGroup/pageinfo";
import { messagingCreatePageInfo } from "./Pages/Messaging/CreatePage/pageinfo";
import { messagingIndexPageInfo } from "./Pages/Messaging/IndexPage/pageinfo";
import { messagingMessageGroupPageInfo } from "./Pages/Messaging/MessageGroup/pageinfo";
import { messagingPageInfo } from "./Pages/Messaging/pageinfo";
import { modelDetailRedirectPageInfo } from "./Pages/ModelDetailRedirectPage/pageinfo";
import { onboardingDisplayNamePageInfo } from "./Pages/Onboarding/DisplayNamePage/pageinfo";
import { onboardingIndexPageInfo } from "./Pages/Onboarding/IndexPage/pageinfo";
import { onboardingNotificationsPageInfo } from "./Pages/Onboarding/NotificationsPage/pageinfo";
import { onboardingPageInfo } from "./Pages/Onboarding/pageinfo";
import { onboardingPrivacyStatementPageInfo } from "./Pages/Onboarding/PrivacyStatementPage/pageinfo";
import { onboardingProfilePageInfo } from "./Pages/Onboarding/ProfilePage/pageinfo";
import { onboardingSuccessPageInfo } from "./Pages/Onboarding/SuccessPage/pageinfo";
import { preferencesPageInfo } from "./Pages/Preferences/pageinfo";
import { rootPageInfo } from "./root.pageinfo";

export const allPages = [
	loginPageInfo,
	logoutPageInfo,
	mfaLoginPageInfo,
	recoverPageInfo,
	setPasswordPageInfo,
	homePageInfo,
	announcementHubCreatePageInfo,
	announcementHubDetailPageInfo,
	announcementHubIndexPageInfo,
	announcementHubPageInfo,
	calendarEventHubCreatePageInfo,
	calendarEventHubDetailPageInfo,
	calendarEventHubIndexPageInfo,
	calendarEventHubPageInfo,
	hubsIndexPageInfo,
	newsletterHubCreatePageInfo,
	newsletterHubDetailPageInfo,
	newsletterHubIndexPageInfo,
	newsletterHubPageInfo,
	permissionGroupHubCreatePageInfo,
	permissionGroupHubDetailPageInfo,
	permissionGroupHubIndexPageInfo,
	permissionGroupHubPageInfo,
	postHubCreatePageInfo,
	postHubDetailPageInfo,
	postHubIndexPageInfo,
	postHubPageInfo,
	userHubCreatePageInfo,
	userHubDetailPageInfo,
	userHubIndexPageInfo,
	userHubPageInfo,
	userGroupHubCreatePageInfo,
	userGroupHubDetailPageInfo,
	userGroupHubIndexPageInfo,
	userGroupHubPageInfo,
	hubsPageInfo,
	messagingCreatePageInfo,
	messagingIndexPageInfo,
	messagingMessageGroupPageInfo,
	messagingPageInfo,
	modelDetailRedirectPageInfo,
	onboardingDisplayNamePageInfo,
	onboardingIndexPageInfo,
	onboardingNotificationsPageInfo,
	onboardingPrivacyStatementPageInfo,
	onboardingProfilePageInfo,
	onboardingSuccessPageInfo,
	onboardingPageInfo,
	preferencesPageInfo,
	rootPageInfo,
];
